import React from "react";
import { Box, LinearProgress, Typography, Button } from "@mui/material";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";

export const renderProgressBar = (
  value,
  onCancel,
  { withInheritedFontFamily = false } = {}
) => {
  const determinate = typeof value === "number";
  const fontFamilySx = withInheritedFontFamily
    ? { fontFamily: "inherit" }
    : {};
  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <LinearProgress
        variant={determinate ? "determinate" : "indeterminate"}
        value={determinate ? value : undefined}
      />
      {determinate && (
        <Typography sx={{ fontSize: "10px", mt: 0.5, ...fontFamilySx }}>
          {`Uploading… ${value}%`}
        </Typography>
      )}
      {onCancel && (
        <Button
          variant="text"
          size="small"
          sx={{
            fontSize: "10px",
            ...fontFamilySx,
            mt: 0.5,
            p: 0,
            minWidth: "auto",
            textTransform: "none",
            display: "block",
          }}
          onClick={(event) => {
            // Stop this from also opening the dropzone's file picker.
            event.stopPropagation();
            onCancel();
          }}
        >
          Cancel
        </Button>
      )}
    </Box>
  );
};

export const ThumbnailFileInput = ({ inputRef, onChange, disabled }) => (
  <input
    type="file"
    accept="image/*"
    ref={inputRef}
    style={{ display: "none" }}
    onChange={onChange}
    disabled={disabled}
  />
);

export const ThumbnailPreview = ({
  thumbnail,
  thumbnailInputRef,
  isUploadingThumbnail,
  handleThumbnailUpload,
}) => (
  <>
    <img
      src={thumbnail}
      alt="Uploaded Thumbnail"
      style={{
        maxWidth: "100%",
        borderRadius: "4px",
        objectFit: "cover",
      }}
    />
    <Button
      variant="contained"
      sx={{
        position: "absolute",
        top: "50%",
        left: "45%",
        borderRadius: "24px",
        fontWeight: 700,
      }}
      startIcon={<AutorenewOutlinedIcon />}
      onClick={() => thumbnailInputRef.current.click()}
      disabled={isUploadingThumbnail}
    >
      Replace
    </Button>
    <ThumbnailFileInput
      inputRef={thumbnailInputRef}
      onChange={handleThumbnailUpload}
      disabled={isUploadingThumbnail}
    />
  </>
);
